import { SVGProps, Ref, forwardRef } from 'react';

export const VideocameraFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.667 2.667C2.667 2.667 0 5.333 0 13.333v5.334c0 8 2.667 10.666 10.667 10.666h4c6.806 0 9.752-1.93 10.48-7.432L29.386 24H32V8h-2.613l-4.24 2.1c-.728-5.503-3.674-7.433-10.48-7.433z"
                fill="currentColor"
            />
        </g>
    </svg>
));
VideocameraFilledSize32Glyph.displayName = 'VideocameraFilledSize32Glyph';
